import { formatPropValue } from '@/components/investigations/entity-detail/mapEntityDetail'
import type { CaseGraphRelationshipDetail } from '@/services/api/cases'
import { EntityPropertiesList } from './EntityInspector'

export function RelationshipPropertiesList({ rel }: { rel: CaseGraphRelationshipDetail }) {
  const props = Object.entries(rel.properties).map(([key, value]) => ({
    key,
    value: formatPropValue(value),
  }))
  return <EntityPropertiesList properties={props} />
}
